import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import InputCustom from '../atoms/input/InputCustom'
import { useState, useEffect } from 'react'
import ButtonCustom from '../atoms/button/ButtonCustom'
import TimeSheetTable from './TimeSheetTable'
import TimeOffTable from './TimeOffTable'
import CommonModal from '../atoms/modal/CommonModal'
import styles from './styles.module.scss'
import DateCustom from '../atoms/input/DateCustom'
import SelectCustom from '../atoms/select/SelectCustom'
import TextArea from '../atoms/textarea/TextArea'
import toast from 'react-hot-toast'
import dayjs from 'dayjs'
function CustomTabPanel(props) {
	const { children, value, index, ...other } = props
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box>{children}</Box>}
		</div>
	)
}

const LeaveDurationOptions = [
	{ label: 'Full Day', value: 'Full Day' },
	{ label: 'Half Day', value: 'Half Day' },
]

const TimeOffTypeOptions = [
	{ label: 'Sick Leave', value: 'Sick Leave' },
	{ label: 'Personal Leave', value: 'Personal Leave' },
	{ label: 'Bereavement', value: 'Bereavement' },
	{ label: 'Unpaid', value: 'Unpaid' },
]

const WEDDING_DEFAULT_OPTIONS = [{ label: 'None', value: 'none' }]

function TimeManagementTabs() {
	const [value, setValue] = useState(0)
	const [search, setSearch] = useState('')
	const [modal, setModal] = useState(null)
	const closeModal = () => {
		setModal(null)
		// Reset forms when closing modals
		setTimeEntryForm({ date: '', wedding: '', task: '', hour: '' })
		setTimeOffForm({ date: '', timeOffType: '', reason: '', leaveDuration: '' })
	}
	const [loading, setLoading] = useState(false)
	const [isSubmitted, setSubmitted] = useState(false)
	const [timeOffRefresh, setTimeOffRefresh] = useState(0)
	const [timeSheetRefresh, setTimeSheetRefresh] = useState(0)
	const [weddingOptions, setWeddingOptions] = useState(WEDDING_DEFAULT_OPTIONS)
	const [weddingLoading, setWeddingLoading] = useState(false)
	const openModal = (modalType) => {
		setModal(modalType)
		// Fetch wedding options when opening Add Entry modal
		if (modalType === 'addEntry') fetchWeddingOptions()
	}
	useEffect(() => {
		if (isSubmitted) setTimeout(() => setSubmitted(false), 4000)
	}, [isSubmitted])

	const fetchWeddingOptions = async () => {
		try {
			setWeddingLoading(true)
			const response = await fetch(
				`${process.env.REACT_APP_REQUEST_URL}/api/v1/staff/get-kazoos-staff`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						'Content-Type': 'application/json',
					},
				}
			)

			const result = await response.json()

			if (result.success && result.kazoos) {
				// Transform API data to dropdown format
				const options = [...result.kazoos.map((kazoo) => ({
					label: kazoo.kazooName || kazoo.name || 'Unnamed Wedding',
					value: kazoo._id,
				})), ...WEDDING_DEFAULT_OPTIONS]
				setWeddingOptions(options)
			} else {
				toast.error('Failed to fetch wedding options')
				setWeddingOptions(WEDDING_DEFAULT_OPTIONS)
			}
		} catch (error) {
			console.error('Error fetching wedding options:', error)
			toast.error('Failed to fetch wedding options')
			setWeddingOptions(WEDDING_DEFAULT_OPTIONS)
		} finally {
			setWeddingLoading(false)
		}
	}
	const [timeOffForm, setTimeOffForm] = useState({
		date: '',
		timeOffType: '',
		reason: '',
		leaveDuration: '',
	})
	const [timeEntryForm, setTimeEntryForm] = useState({
		date: '',
		wedding: '',
		task: '',
		hour: '',
	})

	const mainTabStyle = {
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}
	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	const handleExportClick = async () => {
		try {
			let url, csvHeaders, fileName
			if (isSubmitted) return
			setSubmitted(true)
			if (value === 0) {
				// TimeSheet tab - export time entries
				url = `${process.env.REACT_APP_REQUEST_URL}/api/v2/time-management/time-entry-list?page=1&limit=1000`
				csvHeaders = ['Date', 'Wedding', 'Task', 'Hours']
				fileName = `timesheet-entries-${dayjs().format('YYYY-MM-DD')}.csv`
			} else {
				// TimeOff tab - export time-off requests
				url = `${process.env.REACT_APP_REQUEST_URL}/api/v2/time-management/time-off-request-list?page=1&limit=1000`
				csvHeaders = [
					'Date',
					'Time Off Type',
					'Leave Duration',
					'Reason For Time Off',
					'Status',
				]
				fileName = `time-off-requests-${dayjs().format('YYYY-MM-DD')}.csv`
			}

			if (search && search.trim()) {
				url += `&search=${encodeURIComponent(search.trim())}`
			}

			const response = await fetch(url, {
				method: 'GET',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
				},
			})

			const result = await response.json()

			if (!result.success) {
				toast.error('Failed to fetch data for export')
				return
			}

			// Prepare CSV data based on tab
			let csvData
			if (value === 0) {
				// TimeSheet data
				csvData = result.data.map((item) => [
					dayjs(item.date).format('YYYY-MM-DD'),
					item.kazooId?.kazooName || 'N/A',
					`"${(item.taskDetails || 'N/A').replace(/"/g, '""')}"`, // Escape quotes in task
					item.hour || '0.0',
				])
			} else {
				// TimeOff data
				csvData = result.data.map((item) => [
					dayjs(item.date).format('YYYY-MM-DD'),
					item.timeOffType,
					item.leaveDuration,
					`"${item.reason.replace(/"/g, '""')}"`, // Escape quotes in reason
					item.status.charAt(0).toUpperCase() + item.status.slice(1),
				])
			}

			// Create CSV content
			const csvContent = [
				csvHeaders.join(','),
				...csvData.map((row) => row.join(',')),
			].join('\n')

			// Create and download CSV file
			const blob = new Blob([csvContent], {
				type: 'text/csv;charset=utf-8;',
			})
			const link = document.createElement('a')

			if (link.download !== undefined) {
				const url = URL.createObjectURL(blob)
				link.setAttribute('href', url)
				link.setAttribute('download', fileName)
				link.style.visibility = 'hidden'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}

			toast.success(
				`CSV exported successfully! (${result.data.length} records)`
			)
		} catch (error) {
			console.error('Error exporting CSV:', error)
			toast.error('Failed to export CSV. Please try again.')
		}
	}

	const handleTimeOffSubmit = async () => {
		if (isSubmitted) return
		setSubmitted(true)
		// More robust validation - handle dayjs objects and strings
		const isDateValid =
			timeOffForm.date &&
			(typeof timeOffForm.date === 'string'
				? timeOffForm.date.trim() !== ''
				: timeOffForm.date && dayjs(timeOffForm.date).isValid())
		const isTypeValid =
			timeOffForm.timeOffType && timeOffForm.timeOffType.trim() !== ''
		const isReasonValid =
			timeOffForm.reason && timeOffForm.reason.trim() !== ''
		const isLeaveDurationValid =
			timeOffForm.leaveDuration && timeOffForm.leaveDuration.trim() !== ''

		if (!isDateValid || !isTypeValid || !isReasonValid || !isLeaveDurationValid) {
			toast.error('Please fill in all required fields')
			return
		}

		// Format the date for API submission
		const formattedDate = dayjs(timeOffForm.date).format('YYYY-MM-DD')

		try {
			setLoading(true)
			const response = await fetch(
				`${process.env.REACT_APP_REQUEST_URL}/api/v2/time-management/time-off-request`,
				{
					method: 'POST',
					credentials: 'include',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						...timeOffForm,
						date: formattedDate,
					}),
				}
			)

			const result = await response.json()

			if (result.success) {
				toast.success('Time off request submitted successfully!')
				setTimeOffForm({ date: '', timeOffType: '', reason: '', leaveDuration: '' })
				closeModal()
				// Trigger refresh of TimeOffTable
				setTimeOffRefresh((prev) => prev + 1)
			} else {
				toast.error(result.message || 'Failed to submit request')
			}
		} catch (error) {
			console.error('Error submitting time off request:', error)
			toast.error('Failed to submit request')
		} finally {
			setLoading(false)
		}
	}

	const handleTimeEntrySubmit = async () => {
		if (isSubmitted) return
		setSubmitted(true)
		// Validation - handle different data types properly
		const isDateValid =
			timeEntryForm.date &&
			(typeof timeEntryForm.date === 'string'
				? timeEntryForm.date.trim() !== ''
				: timeEntryForm.date && dayjs(timeEntryForm.date).isValid())
		const isWeddingValid =
			timeEntryForm.wedding && String(timeEntryForm.wedding).trim() !== ''
		const isTaskValid =
			timeEntryForm.task && String(timeEntryForm.task).trim() !== ''
		const isHourValid =
			timeEntryForm.hour &&
			String(timeEntryForm.hour).trim() !== '' &&
			Number(timeEntryForm.hour) > 0

		if (!isDateValid || !isWeddingValid || !isTaskValid || !isHourValid) {
			toast.error('Please fill in all required fields')
			return
		}

		// Format the date for API submission
		const formattedDate = dayjs(timeEntryForm.date).format('YYYY-MM-DD')

		try {
			setLoading(true)
			const response = await fetch(
				`${process.env.REACT_APP_REQUEST_URL}/api/v2/time-management/add-time-entry`,
				{
					method: 'POST',
					credentials: 'include',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						date: formattedDate,
						kazooId: timeEntryForm.wedding === 'none' ? null : timeEntryForm.wedding,
						taskDetails: timeEntryForm.task.trim(),
						hour: String(timeEntryForm.hour),
					}),
				}
			)

			const result = await response.json()

			if (result.success) {
				toast.success('Time entry added successfully!')
				setTimeEntryForm({ date: '', wedding: '', task: '', hour: '' })
				closeModal()
				// Trigger immediate refresh of TimeSheetTable
				setTimeSheetRefresh((prev) => prev + 1)
			} else {
				toast.error(result.message || 'Failed to add time entry')
			}
		} catch (error) {
			console.error('Error adding time entry:', error)
			toast.error('Failed to add time entry')
		} finally {
			setLoading(false)
		}
	}
	return (
		<>
			<Box sx={{ width: '100%' }} className={styles.timeManagementTabs}>
				<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="basic tabs example"
						sx={mainTabStyle}
					>
						<Tab label="TimeSheet" />
						<Tab label="TimeOff" />
					</Tabs>
				</Box>
				<Box className={styles.tabsInner}>
					<CustomTabPanel
						value={value}
						index={0}
						className={styles.profileDetailsWrp}
					>
						<Box className={styles.searchRow}>
							<Grid container spacing={2}>
								<Grid size={{ xs: 12, sm: 4, md: 2.4 }}>
									<div className={styles.searchContainer}>
										<InputCustom
											type="text"
											name="search"
											id="search"
											placeholder="Search"
											error={false}
											searchIcon={true}
											value={search || ''}
											onChange={(e) =>
												setSearch(e.target.value)
											}
										/>
									</div>
								</Grid>
								<Grid size={{ xs: 12, sm: 8, md: 9.6 }}>
									<div className={styles.right}>
										<ButtonCustom
											variant="outlined"
											size="small"
											onClick={handleExportClick}
											style={{ minHeight: '40px' }}
										>
											<img src="/images/export.svg" />
											<Typography variant="body">
												Export
											</Typography>
										</ButtonCustom>
										<ButtonCustom
											variant="default"
											size="lg"
											onClick={() => {
												openModal('addEntry')
											}}
										>
											+ Add Entry
										</ButtonCustom>
									</div>
								</Grid>
							</Grid>
						</Box>
						<TimeSheetTable
							searchTerm={search}
							key={timeSheetRefresh}
						/>
					</CustomTabPanel>
					<CustomTabPanel
						value={value}
						index={1}
						className={styles.profileDetailsWrp}
					>
						<Box className={styles.searchRow}>
							<Grid container spacing={2}>
								<Grid size={{ xs: 12, sm: 4, md: 2.4 }}>
									<div className={styles.searchContainer}>
										<InputCustom
											type="text"
											name="search"
											id="search"
											placeholder="Search"
											error={false}
											searchIcon={true}
											value={search || ''}
											onChange={(e) =>
												setSearch(e.target.value)
											}
										/>
									</div>
								</Grid>
								<Grid size={{ xs: 12, sm: 8, md: 9.6 }}>
									<div className={styles.right}>
										<ButtonCustom
											variant="outlined"
											size="small"
											onClick={handleExportClick}
											style={{ minHeight: '40px' }}
										>
											<img src="/images/export.svg" />
											<Typography variant="body">
												Export
											</Typography>
										</ButtonCustom>
										<ButtonCustom
											variant="default"
											size="lg"
											onClick={() => {
												openModal('RequestTimeOff')
											}}
										>
											+ Request Time Off
										</ButtonCustom>
									</div>
								</Grid>
							</Grid>
						</Box>
						<TimeOffTable
							searchTerm={search}
							key={timeOffRefresh}
						/>
					</CustomTabPanel>
				</Box>
			</Box>
			<CommonModal
				open={modal === 'addEntry'}
				handleClose={closeModal}
				heading="Add Entry"
				className={styles.addEntryModal}
				footerContent={
					<div className={styles.footerBtns}>
						<ButtonCustom
							variant="outlined"
							size="small"
							onClick={closeModal}
							style={{ minHeight: '40px' }}
							disabled={loading}
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleTimeEntrySubmit}
							disabled={loading || isSubmitted}
						>
							{loading ? 'Adding...' : 'Add Entry'}
						</ButtonCustom>
					</div>
				}
			>
				<form className={styles.formWrp}>
					<Grid container spacing={1.5}>
						<Grid size={{ xs: 12, md: 12 }}>
							<div className={styles.formField}>
								<label htmlFor="date" className={styles.label}>
									Date *
								</label>
								<DateCustom
									name="date"
									setDataFunction={setTimeEntryForm}
									data={timeEntryForm}
									value={timeEntryForm.date}
								/>
							</div>
						</Grid>

						<Grid size={{ xs: 12, sm: 12 }}>
							<div className={styles.formField}>
								<label
									htmlFor="Wedding"
									className={styles.label}
								>
									Wedding
								</label>
								<SelectCustom
									label={
										weddingLoading ? 'Loading...' : 'Select'
									}
									options={weddingOptions}
									disabled={weddingLoading}
									defaultValue={timeEntryForm.wedding}
									renderValueAsLabel={true}
									setDataFunction={(selectedOption) => {
										setTimeEntryForm((prev) => ({
											...prev,
											wedding: selectedOption
												? selectedOption.value
												: '',
										}))
									}}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
							<div className={styles.formField}>
								<label htmlFor="Task" className={styles.label}>
									Task *
								</label>
								<TextArea
									name="Task"
									id="Task"
									placeholder="Write here"
									value={timeEntryForm.task}
									onChange={(e) =>
										setTimeEntryForm((prev) => ({
											...prev,
											task: e.target.value,
										}))
									}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
							<div className={styles.formField}>
								<label htmlFor="Hour" className={styles.label}>
									Hours *
								</label>
								<InputCustom
									type="number"
									name="hour"
									id="hour"
									placeholder="0.0"
									step="0.5"
									min="0"
									max="24"
									value={timeEntryForm.hour}
									onChange={(e) =>
										setTimeEntryForm((prev) => ({
											...prev,
											hour: e.target.value,
										}))
									}
								/>
							</div>
						</Grid>
					</Grid>
				</form>
			</CommonModal>
			<CommonModal
				open={modal === 'RequestTimeOff'}
				handleClose={closeModal}
				heading="Request Time Off"
				className={styles.addEntryModal}
				footerContent={
					<div className={styles.footerBtns}>
						<ButtonCustom
							variant="outlined"
							size="small"
							onClick={closeModal}
							style={{ minHeight: '40px' }}
							disabled={loading}
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleTimeOffSubmit}
							disabled={loading || isSubmitted}
						>
							{loading ? 'Submitting...' : 'Add Request'}
						</ButtonCustom>
					</div>
				}
			>
				<form className={styles.formWrp}>
					<Grid container spacing={1.5}>
						<Grid size={{ xs: 12, md: 12 }}>
							<div className={styles.formField}>
								<label htmlFor="date" className={styles.label}>
									Date *
								</label>
								<DateCustom
									name="date"
									setDataFunction={setTimeOffForm}
									data={timeOffForm}
								/>
							</div>
						</Grid>

						<Grid size={{ xs: 12, sm: 12 }}>
							<div className={styles.formField}>
								<label
									htmlFor="TimeOffType"
									className={styles.label}
								>
									Time Off Type *
								</label>
								<SelectCustom
									label="Select"
									options={TimeOffTypeOptions}
									defaultValue={timeOffForm.timeOffType}
									setDataFunction={(selectedOption) => {
										setTimeOffForm((prev) => ({
											...prev,
											timeOffType: selectedOption
												? selectedOption.value
												: '',
										}))
									}}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12, sm: 12 }}>
							<div className={styles.formField}>
								<label
									htmlFor="Duration"
									className={styles.label}
								>
									Leave Duration *
								</label>
								<SelectCustom
									label="Select"
									options={LeaveDurationOptions}
									defaultValue={timeOffForm.leaveDuration}
									setDataFunction={(selectedOption) => {
										setTimeOffForm((prev) => ({
											...prev,
											leaveDuration: selectedOption
												? selectedOption.value
												: '',
										}))
									}}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
							<div className={styles.formField}>
								<label
									htmlFor="Reason for Time Off"
									className={styles.label}
								>
									Reason for Time Off *
								</label>
								<TextArea
									name="reason"
									id="reason"
									placeholder="Write here"
									value={timeOffForm.reason}
									onChange={(e) =>
										setTimeOffForm((prev) => ({
											...prev,
											reason: e.target.value,
										}))
									}
								/>
							</div>
						</Grid>
					</Grid>
				</form>
			</CommonModal>
		</>
	)
}

export default TimeManagementTabs
